import React from 'react';
import { Organization } from 'src/common/interfaces/organization.interface';
import { OrganizationForm } from './organization-form';
import { useCurrentOrganization } from 'src/store/organization';

export const CreateOrganizationForm = () => {
  const switchOrganization = useCurrentOrganization((state) => state.switchOrganization);

  const onSubmit = async (response: Organization) => {
    try {
      switchOrganization(response.id, true);
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <div className='flex flex-col'>
      <div className='flex'>
        <p className='text-bedrock-p'>
          New organizations are{' '}
          <span className='text-bedrock-p-strong'>entirely seperate from your existing organization</span> and require
          new billing details and a different subdomain - perhaps you're looking to create a new workspace.
        </p>
      </div>
      <div className='mt-lg'>
        <OrganizationForm
          formClassName='w-full'
          currentOrganization={null}
          submitLabel='Create new organization'
          onSubmit={onSubmit}
          stretchSaveButton
        />
      </div>
    </div>
  );
};
